import { Injectable } from '@angular/core';
import { User } from '../_models/user';

export interface AdminMenuItem {
  labelKey: string; // chave de tradução (assets/i18n)
  icon?: string;
  route?: string;
  masterAdmin?: boolean;
  isDocsiaTeamMember?: boolean;
}

// Itens de configuração exibidos no menu do usuário (antes ficavam na engrenagem do header)
@Injectable({ providedIn: 'root' })
export class ControlSidebarService {
  private items: AdminMenuItem[] = [
    { labelKey: 'SHARED.adminCompanies', icon: 'fas fa-building', route: '/admin/empresas' },
    { labelKey: 'SHARED.adminUsers', icon: 'fas fa-user', route: '/admin/usuarios', masterAdmin: true },
    { labelKey: 'SHARED.adminAreas', icon: 'fas fa-sitemap', route: '/admin/areas' },
    { labelKey: 'SHARED.adminRoles', icon: 'fas fa-user-circle', route: '/admin/roles' },
    { labelKey: 'SHARED.adminDocTypes', icon: 'fas fa-list-alt', route: '/admin/categorias', masterAdmin: true },
    { labelKey: 'SHARED.adminAccessControl', icon: 'fas fa-eye', route: '/admin/access-control', masterAdmin: true },
    { labelKey: 'SHARED.adminReportVolumetry', icon: 'far fa-clipboard', route: '/admin/relatorio-volumetria', masterAdmin: true, isDocsiaTeamMember: true },
    { labelKey: 'SHARED.adminReportVolumetryClient', icon: 'far fa-clipboard', route: '/admin/relatorio-volumetria-por-cliente', masterAdmin: true, isDocsiaTeamMember: true },
    { labelKey: 'SHARED.adminReportExtraction', icon: 'far fa-clipboard', route: '/admin/relatorio-extracao', masterAdmin: true, isDocsiaTeamMember: true },
  ];

  // Regras de visibilidade (mantidas da engrenagem):
  // - masterAdmin: vê os itens sem flag ou com masterAdmin; os com isDocsiaTeamMember só se for do time Docs IA
  // - demais admins: só os itens sem a flag masterAdmin
  getMenuItems(user: User | null | undefined): AdminMenuItem[] {
    if (!user?.isAdmin) {
      return [];
    }
    if (user.masterAdmin) {
      return this.items.filter(i =>
        (!('masterAdmin' in i) || i.masterAdmin) &&
        (!('isDocsiaTeamMember' in i) || !!user.isDocsiaTeamMember));
    }
    return this.items.filter(i => !i.masterAdmin);
  }
}
